import React, {
    useEffect,
    useState,
    useCallback,
    useRef,
    useMemo,
    memo,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import axios from "axios";
import {
    BOBADMIN,
    DESC,
    EA,
    FOLLOWUP,
    REVIEW,
    REVIEWADMIN,
    REVIEWSCHEDULER,
    shortTZMap,
    SUPER_ADMIN,
    TYPE_OF_CALL,
    TYPE_TO_FILTER_BY_APPOINTMENT_TIME,
    TYPE_TO_FILTER_BY_ATTEMPTS,
    TYPE_TO_FILTER_BY_FIRST_NAME,
    TYPE_TO_FILTER_BY_NAME,
    TYPE_TO_FILTER_BY_PHONE,
    TYPE_TO_FILTER_BY_SCHEDULE_WITH,
    TYPE_TO_FILTER_BY_WHO_CREATED,
    tzMap,
    UTC,
    VONBOARDER,
} from "../../utils/Constants";
import { Link } from "react-router-dom";
import {
    Card,
    Icon,
    Button,
    Tooltip,
    message,
    Input,
    Pagination,
    Spin,
    Select,
    DatePicker,
    Row,
    Col,
    Switch,
} from "antd";
import Cookies from "js-cookie";
import SetupAppointment from "../LandingPage/parts/setup-appointment-modal";
import moment from "moment";
import F from "../../Functions";
import index, { Translate } from "react-translated";
import { get_label_from_value } from "../../utils/Constants";
import CommonHeader from "./CommonHeader";
import EaDateFilter from "./parts/EA_And_LSP/DateFilter";
import ToggleButtonGrid from "./parts/vonboard/toggle-button-grid";
import ButtonCellRenderer from "./parts/vonboard/button-cell-renderer";
import NameCellRenderer from "./parts/reviewscheduler/name-cell-render";
import CustomHeader from "../../CommonHeader/CustomHeader";
import "../../Common-Table/CustomAgGridTable.css";
import ActionMenu from "../LandingPage/menu";

// store
import { useBoundStore } from "../../store/useBoundStore";
import CustomAgGridTable from "../../Common-Table/CustomAgGridTable";
import BadNumberTooltip from "../../Custom-Tooltip/BadNumberTooltip";
import { debounce, orderBy, stubTrue } from "lodash";
import {
    GET_FS_UPCOMING_CALLS,
    GET_FS_DUE_CALLS,
    GET_FS_APPOINTMENT_SCHEDULED,
    GET_FS_NON_RESPONSIVE,
    GET_FS_NOT_INTERESTED,
    GET_FS_REQUESTED_RESCHEDULED,
    GET_RS_ACTIVE_CALLS,
    GET_RS_APPOINTMENTS_SCHEDULED,
    GET_RS_DUE_CALLS,
    GET_RS_NON_RESPONSIVE,
    GET_RS_NOT_INTERESTED,
    GET_RS_REQUESTED_RESCHEDULED,
    GET_RS_BAD_PHONE_NUMBERS,
    GET_RS_UPCOMING_CALLS,
    GET_FS_BAD_PHONE_NUMBERS,
    GET_FS_ACTIVE_CALLS,
    GET_FS_CLAIMED_CALLS,
    GET_RS_ADMIN_CALL_DATA,
    GET_RS_AGENT_LISTING,
    GET_FS_ADMIN_GRID_DATA,
    GET_NOT_INTERESTED_HISORICAL_DATA,
    GET_APPOINTMENT_HISTORY_HISTORICAL_DATA,
    GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    GET_CALL_ATTEMPS_HISTORY_DETAILS,
    GET_CALL_BACK_HISTORY_DETAILS,
    GET_AGENT_LISTING,
    RS_DEDICATED_AGENCIES_API_URL_V2,
    AGENT_SEARCH_API_URL,
    RS_ALL_AGENCIES_API_URL,
    GET_FS_ADMIN_QUEUED_BFILES,
    GET_RS_ADMIN_QUEUED_BFILES,
    GET_FS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID,
    GET_RS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID,
    GET_FS_ALL_AGENCIES,
    FS_AGENCIES_ASSOC,
    VONBOARDER_AGENCIES_API_URL,
    FS_DIALS_MADE_GRID,
    RS_DIALS_MADE_GRID,
    GET_RS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID_INACTIVE_AGENCIES,
    GET_FS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID_INACTIVE_AGENCIES,
} from "../../utils/Api_enums";
import UserStatsModal from "./parts/review-admin/UserStatsModal";
import { GET_GRID_CARD_ROWDATA } from "./parts/review-admin/grid/RS-FS-Admin-Buckets";
import QuickNavigationModal from "./parts/review-admin/QuickNavigationModal";
import { useRangePickerCloseButton } from "../../utils/rangePickerCloseButton";

const { Option } = Select;
const { RangePicker } = DatePicker;

const RSFSGrid = (props) => {
    const [open, setOpen] = useState(false);
    useRangePickerCloseButton(open, setOpen);
    const {
        RSFSFilters,
        setRSFSFilters,
        resetRSFSFilters,
        RSFSCardFilters,
        setRSFSCardFilters,
    } = useBoundStore();
    const didMountRef = useRef(false);
    const resetHandlers = useRef([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Add window resize handler
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Update useEffect for style injection with specific class
    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerText = `
            .agent-search-select .ant-select-selection {
                width: ${windowWidth <= 509 ? "150px" : "100%"} !important;
            }
            .agent-search-select .ant-select-selection__rendered {
                width: 100% !important;
            }
            .agent-search-select .ant-select-selection--multiple .ant-select-selection__rendered {
                width: 100% !important;
            }
            .agent-search-select .ant-select-selection--multiple .ant-select-selection__choice {
                max-width: calc(100% - 20px);
                overflow: hidden;
                text-overflow: ellipsis;
            }
        `;
        document.head.appendChild(styleSheet);

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, [windowWidth]); // Add windowWidth as dependency

    // useEffect(() => {
    //     setRSFSFilters({
    //         selectedButton: RSFSCardFilters.selectedButton,
    //         selectedAgency: RSFSCardFilters.selectedAgency,
    //         selectedFilterOption: RSFSCardFilters.selectedFilterOption,
    //         datemodified: RSFSCardFilters.datemodified || {
    //             start_date: null,
    //             end_date: null
    //         }
    //     });
    // }, [RSFSCardFilters, setRSFSFilters]);

    const [buckets, setBuckets] = useState(
        JSON.parse(localStorage.getItem("buckets")) || [],
    );
    const [callCountBucket, setCallCountBuckets] = useState(
        JSON.parse(localStorage.getItem("callCounts")) || [],
    );
    const [isBadPhoneNumber, setIsBadPhoneNumber] = useState(
        RSFSFilters.hideBadPhoneNumber,
    );
    const [selectedButton, setSelectedButton] = useState(
        RSFSFilters.selectedButton,
    );
    const [selectedAgency, setSelectedAgency] = useState(
        RSFSFilters.selectedAgency,
    );
    const [selectedAgent, setSelectedAgent] = useState(RSFSFilters.selectedAgent);
    const [selectedFilterOption, setSelectedFilterOptions] = useState(
        RSFSFilters.selectedFilterOption,
    );
    const initialDateRange = {
        start_date: RSFSFilters.datemodified.start_date || "2010-01-01",
        end_date: RSFSFilters.datemodified.end_date || "2050-01-01",
    };
    const [datemodified, setdatemodified] = useState(initialDateRange);
    const card = JSON.parse(localStorage.getItem("card"));
    const [gridApiOptions, setGridApiOptions] = useState({
        api: null,
        columnApi: null,
    });
    const [fetching, setFetching] = useState(false);
    const [gridKey, setGridKey] = useState(0);

    // Direct container reference to override App.js configuration
    const getCustomContainer = () => document.body;
    const handleFilterResetHandler = (resetFn) => {
        resetHandlers.current.push(resetFn);
    };

    useEffect(() => {
        setSelectedButton(RSFSFilters.selectedButton);
        setSelectedAgency(RSFSFilters.selectedAgency);
        setSelectedFilterOptions(RSFSFilters.selectedFilterOption);
        setdatemodified({
            start_date: RSFSFilters.datemodified.start_date || null,
            end_date: RSFSFilters.datemodified.end_date || null,
        });
    }, [RSFSFilters]);

    const query = new URLSearchParams(
        (props.location && props.location.search) || "",
    );
    const title = query.get("title");

    const [columnDefs, setColumnDefs] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [pages, setPages] = useState(1);
    let customUserTypeData = localStorage.getItem("customUserType");
    const [customUserType, setCustomUserType] = useState(customUserTypeData);
    const userId = props.auth.user.id;
    const [user, setUser] = useState(props.auth.user);
    const [typeOfCall, setTypeOfCall] = useState([
        {
            id: "AllBFiles",
            name: "All B Files",
        },
        {
            id: "Prospect",
            name: "Leads",
        },
        {
            id: "FollowUp",
            name: "Opportunities",
        },
    ]);
    const [filters, setFilters] = useState("");
    const [gridApi, setGridApi] = useState(null);
    const [columnApi, setColumnApi] = useState(null);
    const gridRef = useRef();
    const [totalRows, setTotalRows] = useState(0);

    const [loading, setLoading] = useState(false);
    const antIcon = <Icon type="loading" style={{ fontSize: 32 }} spin />;
    const [period, setPeriod] = useState("all_bfiles");
    const [start_date, setStartDate] = useState(null);
    const [end_date, setEndDate] = useState(null);

    const [filters_data, setFilterData] = useState({
        search: "",
        agency: "",
    });

    const [roles, setRoles] = useState(JSON.parse(localStorage.getItem("roles")));
    const getFilterOption = () => {
        let arr = [];
        const zustandState = useBoundStore.getState().RSFSCardFilters;
        let selectedToggleAPI = zustandState.selectedToggleAPI;

        const hasFollowUp = roles.includes("FollowUp");
        const hasProspect = roles.includes("Prospect");
        const hasReview = roles.includes("Review");

        if (!selectedToggleAPI) {
            if (hasReview) {
                selectedToggleAPI = REVIEWSCHEDULER;
            } else {
                selectedToggleAPI = VONBOARDER;
            }
        }

        if (selectedToggleAPI === REVIEWSCHEDULER) {
            arr.push({ id: 1, key: "AllBFiles", value: "All B Files" });
        } else {
            // arr.push({ id: 1, key: "AllBFiles", value: "All B Files" });
            if (hasFollowUp && hasProspect) {
                arr.push({ id: 1, key: "AllBFiles", value: "All B Files" });
            }
            if (hasProspect) {
                arr.push({ id: 2, key: "Prospect", value: "Leads" });
            }
            if (hasFollowUp) {
                arr.push({ id: 3, key: "FollowUp", value: "Opportunities" });
            }
        }

        return arr;
    };

    const [filterOptions, setFilterOptions] = useState(getFilterOption);

    useEffect(() => {
        if (!RSFSCardFilters.selectedToggleAPI) {
            setRSFSCardFilters({
                selectedToggleAPI: roles.includes("Review") ? REVIEWSCHEDULER : VONBOARDER,
            });
        }
    }, [RSFSCardFilters.selectedToggleAPI, roles, setRSFSCardFilters]);

    const [selectedRows, setSelectedRows] = useState([]);
    const [appointmentModal, setAppointmentModal] = useState(false);
    const [selectedRowData, setSelectRowData] = useState();
    const [agencies, setAgencies] = useState([]);
    const [agents, setAgents] = useState([]);

    const [afterSwitch, setAfterSwitch] = useState();

    const [sortOrders, setSortOrders] = useState({});
    const [currentPage, setCurrentPage] = useState(RSFSFilters.page);
    const pageSize = 10;
    const [totalPages, setTotalPages] = useState(1);
    const apiMapForFS = {
        0: GET_FS_CLAIMED_CALLS,
        1: GET_FS_ACTIVE_CALLS,
        2: GET_FS_DUE_CALLS,
        3: GET_FS_NOT_INTERESTED,
        4: GET_FS_UPCOMING_CALLS,
        5: GET_FS_NON_RESPONSIVE,
        6: GET_FS_BAD_PHONE_NUMBERS,
        7: GET_FS_APPOINTMENT_SCHEDULED,
        8: GET_FS_REQUESTED_RESCHEDULED,
        28: GET_FS_ADMIN_QUEUED_BFILES,
        29: GET_FS_ADMIN_QUEUED_BFILES,
        30: GET_FS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID,
        31: GET_FS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID_INACTIVE_AGENCIES,
    };

    const apiMapForRS = {
        1: GET_RS_ACTIVE_CALLS,
        2: GET_RS_DUE_CALLS,
        3: GET_RS_NOT_INTERESTED,
        4: GET_RS_UPCOMING_CALLS,
        5: GET_RS_NON_RESPONSIVE,
        6: GET_RS_BAD_PHONE_NUMBERS,
        7: GET_RS_APPOINTMENTS_SCHEDULED,
        8: GET_RS_REQUESTED_RESCHEDULED,
        28: GET_RS_ADMIN_QUEUED_BFILES,
        29: GET_RS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID,
        30: GET_RS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID_INACTIVE_AGENCIES,
    };

    const getSubTypeNames = (subTypes = []) => {
        return subTypes.map((item) => item.sub_type_of_call).join(", ");
    };

    const getHistoricalGridApi = (dashboard_stats) => {
        switch (dashboard_stats) {
            case "total_appointments":
            case "phone_appointments":
            case "virtual_appointments":
            case "office_appointments":
            case "reschedule_appointments":
            case "FollowUp":
            case "Prospect":
                return GET_APPOINTMENT_HISTORY_HISTORICAL_DATA;
            case "Thank You / Referrals":
            case "Life Insurance":
            case "Retirement":
            case "Commercial":
            case "Re-Quote":
            case "Win Back":
            case "Event Call":
            case "P&C Review":
            case "Cross-Sell":
                return GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY;
            case "total_not_interested":
                return GET_NOT_INTERESTED_HISORICAL_DATA;
            case "total_call_attempts":
                return GET_CALL_ATTEMPS_HISTORY_DETAILS;
            case "total_call_backs":
                return GET_CALL_BACK_HISTORY_DETAILS;
            default:
                throw new Error(`Unsupported key: ${dashboard_stats}`);
        }
    };

    const [gridReady, setGridReady] = useState(false);
    const [searchText, setSearchText] = useState(RSFSFilters.searchText);

    const dateFormat = "MM-DD-YYYY";
    const today = new Date();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isQuickNavModalOpen, setIsQuickNavModalOpen] = useState(false);
    const handleIconClick = () => {
        setSortOrders({});
        const card = JSON.parse(localStorage.getItem("card"));
        setRSFSFilters({
            previousTitle: card.dashboard_stats,
            filter_by_column_name: undefined,
            filter: "",
            direction: "",
            // hideBadPhoneNumber: 1
        });
        let userType = card.role == REVIEWSCHEDULER ? REVIEWADMIN : BOBADMIN;
        localStorage.setItem(
            "buckets",
            JSON.stringify(GET_GRID_CARD_ROWDATA(userType)),
        );
        setIsModalOpen(true);
        // setIsBadPhoneNumber(true);
        //updateCallsCount(props.data.id, props.data.data, props.data.userType);
    };


    const getDefaultDateRange = (agencies, selectedAgency) => {
        const userInfo = useBoundStore.getState().userInfo;
        let startDate = "2010-01-01";
        let endDate = userInfo.user_type == SUPER_ADMIN ?
            moment("2050-01-01").format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");

        if (agencies.length > 0) {
            let targetAgency = null;

            if (selectedAgency) {
                targetAgency = agencies.find(
                    (a) => Number(a.id) === Number(selectedAgency)
                );
            }

            if (!targetAgency) {
                //default oldest created agency 
                targetAgency = agencies.reduce((oldest, current) =>
                    moment(current.start_date).isBefore(moment(oldest.start_date))
                        ? current
                        : oldest
                );
            }

            if (targetAgency.start_date) {
                startDate = moment(targetAgency.start_date).format("YYYY-MM-DD");
            }
        }

        return { start_date: startDate, end_date: endDate };
    };

    const handleQuickNavigationModal = () => {
        setSortOrders({});
        const card = JSON.parse(localStorage.getItem("card"));
        setRSFSFilters({
            previousTitle: card.dashboard_stats,
            filter_by_column_name: undefined,
            filter: "",
            direction: "",
            // hideBadPhoneNumber: 1
        });
        setIsQuickNavModalOpen(true);
        // setIsBadPhoneNumber(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleQuickNavigationModalClose = () => {
        setIsQuickNavModalOpen(false);
    };

    const searchTimeout = useRef(null);

    const handleFilter = (field, value, inputType) => {
        const dateFilterDates = RSFSFilters.datemodified;
        setCurrentPage(1);
        setLoading(true);

        const card = JSON.parse(localStorage.getItem("card"));
        resetRSFSFilters();
        setRSFSFilters({
            datemodified: dateFilterDates
        })

        const DATE_FIELDS = [
            "rs_effective_date",
            "expiration_date",
            "rs_appointment_date",
            "appointment_date",
            "von_appointment_date",
            "rs_notreached_date",
            "fs_notreached_date",
            "fs_effective_date",
            "fs_scheduled_by_date",
            "external_updated_on"
        ];

        const FIELD_MAPPINGS = {
            first_name: "name",
            sub_type: "sub_type_of_call",
            user_name: "who_created",
            attempts: "rs_attempts",
            sub_types: "sub_type_of_call",
            full_name: "who_created",
            // bfile_user_full_name: 'who_created',
            bfile_user: "who_created",
        };

        if (DATE_FIELDS.includes(field)) {
            const isFollowUpActiveMonth =
                field === "fs_effective_date" && inputType === "select" && value;
            const selectedMonth = isFollowUpActiveMonth
                ? moment().month(Number(value) - 1)
                : null;
            let startDate = selectedMonth
                ? selectedMonth.clone().startOf("month").format("YYYY-MM-DD")
                : moment((value && value.start_date) || "2010-01-01").format("YYYY-MM-DD");
            let endDate = selectedMonth
                ? selectedMonth.clone().endOf("month").format("YYYY-MM-DD")
                : moment((value && value.end_date) || "2050-01-01").format("YYYY-MM-DD");


            if (field === "rs_effective_date") {
                if (card.role == REVIEWSCHEDULER) {
                    field = "review_active_month";
                    setRSFSFilters({
                        filter_by_column_name: { [field]: value },
                        page: 1,
                    });
                } else {
                    setRSFSFilters({
                        datemodified: { start_date: startDate, end_date: endDate, page: 1 },
                    });
                }
            } else {
                if (card.role === VONBOARDER && field === "expiration_date") {
                    field = "fs_expiration_date";
                } else if (field === "appointment_date" && !card.isHistoricalGrid) {
                    field =
                        card.role === REVIEWSCHEDULER
                            ? "rs_appointment_date"
                            : "von_appointment_date";
                } else if (field === "fs_effective_date") {
                    field = "fs_effective_date";
                } else if (field == "fs_scheduled_by_date") {
                    startDate = moment(startDate)
                        .subtract(30, "days")
                        .format("YYYY-MM-DD");
                    endDate = moment(endDate)
                        .subtract(30, "days")
                        .format("YYYY-MM-DD");
                    field = "fs_effective_date";
                }

                const formattedDate = {
                    [field]: { from: startDate, to: endDate },
                };


                setRSFSFilters({
                    filter_by_column_name:
                        formattedDate, page: 1
                });
            }


            getGridData();
            return;
        }

        if (field === "agency__name") {
            setRSFSFilters({ selectedAgency: value, page: 1 });
            getGridData();
            return;
        }

        if (field === "type_of_call") {
            setRSFSFilters({ selectedFilterOption: value, page: 1 });
            getGridData();
            return;
        }

        if (field == "attempts" && card.role == VONBOARDER) {
            setRSFSFilters({
                filter_by_column_name: { fs_call_attempts: value },
                page: 1,
            });
            getGridData();
            return;
        }

        const mappedField = FIELD_MAPPINGS[field] || field;
        if (mappedField == "rs_attempts") {
            setRSFSFilters({
                filter_by_column_name: { [mappedField]: Number(value) },
                page: 1,
            });
        } else {
            setRSFSFilters({
                filter_by_column_name: { [mappedField]: value },
                page: 1,
            });
        }

        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            getGridData();
        }, 500);
    };

    const handleSort = (field) => {
        setLoading(true);
        setSortOrders((prev) => {
            const currentOrder = prev[field] || "asc";
            const newOrder = currentOrder === "asc" ? "desc" : "asc";
            setRSFSFilters({ field: field, direction: newOrder });
            setCurrentPage(1);
            getGridData();
            return { ...prev, [field]: newOrder };
        });
    };

    const handleBadPhoneNumberToggle = (event) => {
        setIsBadPhoneNumber(event.target.checked);
        let value = event.target.checked ? 1 : 0;
        setRSFSFilters({ hideBadPhoneNumber: value });
        getGridData();
    };

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const onFilterChange = (value) => {
        setSelectedFilterOptions(value);
        setRSFSFilters({ selectedFilterOption: value });
        getGridData();
    };

    const onPageChange = (page) => {
        const card = JSON.parse(localStorage.getItem("card"));
        setRSFSFilters({ page: page });
        setCurrentPage(page);
        if (card.role == REVIEWSCHEDULER) {
            rsApiFilter(card.index, true);
        } else {
            prepareApiFilterForFS({ sec: card.index, page: page, changePage: true });
        }
    };

    useEffect(() => {
        if (didMountRef.current) {
            getRSFSGridDataOnNavigation();
        } else {
            didMountRef.current = true;
        }
    }, [title]);

    const getRSFSGridDataOnNavigation = () => {
        const card = JSON.parse(localStorage.getItem("card"));
        if (title && (card.back_to_dashboard || card.quickNavigation)) {
            const localBuckets =
                JSON.parse(localStorage.getItem("callCounts")) ||
                JSON.parse(localStorage.getItem("buckets")) ||
                [];
            const item =
                // (buckets && buckets.find(b => b.title === title)) ||
                localBuckets && localBuckets.find((b) => b.title === title);

            if (item) {
                item.userName = card.userName || "";
                item.start_date = card.start_date;
                item.end_date = card.end_date;
                item.user_id = card.user_id;
                console.log(item.title);

                if (
                    item.title == "Bad Phone Numbers" ||
                    item.title == "Bad Phone Number"
                ) {
                    setRSFSFilters({
                        hideBadPhoneNumber: 0,
                    });
                    setIsBadPhoneNumber(false);
                } else {
                    setRSFSFilters({
                        hideBadPhoneNumber: 1,
                    });
                    setIsBadPhoneNumber(true);
                }

                localStorage.setItem("card", JSON.stringify(item));
                prepareGridColumn();
                getGridData();
            }
        }
    };

    useEffect(() => {
        if (agencies.length > 0) {
            getGridColumn();
        }
        getGridColumn();
    }, [agencies]);

    useEffect(() => {
        prepareGridColumn();
    }, []);

    // useEffect(() => {
    //     if (columnDefs.length > 0) {
    //         getGridData();
    //     }
    // }, [columnDefs]);

    useEffect(() => {
        if (searchText || searchText == "") {
            debouncedLoadCalls(searchText);
        }
    }, [searchText]);

    // useEffect(() => {
    //     setRSFSFilters({
    //         hideBadPhoneNumber: 1
    //     });
    //     setIsBadPhoneNumber(true);
    // }, [props.location]);

    const debouncedLoadCalls = useCallback(
        debounce((value) => {
            const looksLikePhone = /[\d\(\)\-\s]+$/.test(value);
            const cleanedValue = looksLikePhone ? value.replace(/\D/g, "") : value;
            setRSFSFilters({ searchText: cleanedValue.trim(), page: 1 });
            setCurrentPage(1);
            // prepareGridColumn();
            getGridData();
        }, 500),
        [pages],
    );


    const refresh = () => {
        resetHandlers.current.forEach((reset) => reset());

        setSelectedAgent([]);
        setAgents([]);
        setCurrentPage(1);

        setSelectedAgency(undefined);
        setIsBadPhoneNumber(true);
        filters_data.agency = "";

        setStartDate(null);
        setEndDate(null);
        setSelectedFilterOptions(undefined);
        setSearchText(undefined);

        const dateRange = getDefaultDateRange(agencies, undefined);

        setdatemodified(dateRange);
        setSelectedButton("AllBFiles");

        resetRSFSFilters();

        setRSFSFilters({
            datemodified: dateRange,
            selectedButton: "AllBFiles",
            selectedFilterOption: "AllBFiles",
        });

        localStorage.removeItem("agGridColumnState");

        if (columnApi) {
            columnApi.resetColumnState();
            columnApi.resetColumnGroupState();
        }

        getGridColumn();
        getGridData();
    };

    // const refresh = () => {
    //     resetHandlers.current.forEach((reset) => reset());
    //     setSelectedAgent([]);
    //     setAgents([]);
    //     setCurrentPage(1);
    //     const dateRange = {
    //         start_date: "2010-01-01",
    //         end_date: "2050-01-01",
    //     };
    //     setSelectedAgency(undefined);
    //     setIsBadPhoneNumber(true);
    //     filters_data.agency = "";

    //     setStartDate(null);
    //     setEndDate(null);
    //     setdatemodified(dateRange);
    //     setSelectedFilterOptions(undefined);
    //     setSearchText(undefined);
    //     setSelectedButton("AllBFiles");
    //     resetRSFSFilters();
    //     setRSFSFilters({
    //         selectedButton: "AllBFiles",
    //         selectedFilterOption: "AllBFiles",
    //     });

    //     localStorage.removeItem("agGridColumnState");

    //     if (columnApi) {
    //         columnApi.resetColumnState();
    //         columnApi.resetColumnGroupState();
    //     }
    //     getGridColumn();
    //     getGridData();
    // };

    const getGridData = ({ field, orderBy, searchByName } = {}) => {
        const card = JSON.parse(localStorage.getItem("card"));
        if (card.role == REVIEWSCHEDULER) {
            rsApiFilter(card.index, false);
        } else {
            prepareApiFilterForFS({
                sec: card.index,
                page: 1,
                feild: field,
                orderBy: orderBy,
            });
        }
    };

    const prepareGridColumn = () => {
        const card = JSON.parse(localStorage.getItem("card"));
        getGridColumn();
        if (card.role == REVIEWSCHEDULER) {
            rsColumnDef(card.dashboard_stats);
            if (card.back_to_dashboard && card.user_id) {
                //on the basis of selected scheduler (user_id)
                fetchRSAgenciesById(card.user_id);
            } else if (card.isRSUser) {
                //called for a normal RS/RFS (thru manage scheduler)
                fetchRSAgencies();
            } else {
                //for normal admin dashboard
                fetchAllRSAgencies();
            }
        } else {
            fsColumnDef(card.dashboard_stats);
            if (card.back_to_dashboard && card.user_id) {
                //on the basis of selected scheduler (user_id)
                fetchFSAgenciesById(card.user_id);
            } else if (card.isFSUser) {
                //called for a normal RS/RFS (thru manage scheduler)
                fetchFSAgencies();
            } else {
                //for normal admin dashboard
                fetchAllFSAgencies();
            }
        }
    };

    const getGridColumn = () => {
        const card = JSON.parse(localStorage.getItem("card"));
        const columns = getColumns();
        if (card.role == REVIEWSCHEDULER) {
            rsColumnDef(columns, card.dashboard_stats);
        } else {
            fsColumnDef(columns, card.dashboard_stats);
        }
    };

    const getColumns = () => {
        const card = JSON.parse(localStorage.getItem("card"));
        return {
            name: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Name"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    api: params.api,
                    field: "first_name",
                    sortOrder: sortOrders["first_name"],
                    handleSort,
                    handleFilter,
                    placeholder: TYPE_TO_FILTER_BY_NAME,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                }),
                field: "first_name",
                // floatingFilter: true,
                cellRenderer: "CreateNameRendererRS",
                sortable: true,
                filter: true,
                autoHeight: true,
                autoHeaderHeight: true,
                width: 250,
            },
            phone: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Phone"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    api: params.api,
                    field: "phone",
                    handleFilter,
                    placeholder: TYPE_TO_FILTER_BY_PHONE,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                    // sortOrder: sortOrders["phone"],
                    // handleSort
                }),
                headerName: "Phone",
                colId: "Phone",
                field: "phone",
                cellRenderer: "CreatePhoneCellRenderer",
                sortable: false,
                filter: true,
                autoHeight: true,
            },
            agency: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerName: "Agency",
                headerComponentParams: (params) => ({
                    headers: ["Agency"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "agency__name",
                    api: params.api,
                    sortOrder: sortOrders["agency__name"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "select",
                    options: agencies,
                    handleFilterResetHandler,
                }),
                field: "agency_name",
                sortable: true,
                filter: true,
                width: 350,
                autoHeight: true,
            },
            typeOfCall: {
                headerClass: "custom-ag-header",
                headerName: "Type Of Call",
                width: "300",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Type of Call"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "type_of_call",
                    sortOrder: sortOrders["type_of_call"],
                    handleSort,
                    handleFilter,
                    showPopOver: card.role == REVIEWSCHEDULER ? false : true,
                    inputType: "select",
                    options:
                        card.role == REVIEWSCHEDULER ? F.getTypeOFCallCRM() : typeOfCall,
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data || !params.data.type_of_call) return "-";
                    return F.transformCallTypeLabel(params.data.type_of_call);
                },
                // sortable: card.role == REVIEWSCHEDULER ? false : true,
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            //FOR FS
            activeCallDate: {
                headerClass: "custom-ag-header",
                headerName: "Follow Up Active Month",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Follow Up Active Month"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "fs_effective_date",
                    sortOrder: sortOrders["fs_effective_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    // inputType: "date",
                    inputType: "select",
                    options: F.getMonths(),
                    handleFilterResetHandler,
                }),
                // valueGetter: (params) => {
                //     if (!params.data) return "";
                //     return (
                //         dateFormatterUTC(params.data.active_call_date) ||
                //         dateFormatter(params.data.rs_effective_date)
                //     );
                // },
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return F.getMonthFromDate(params.data.active_call_date, 'FS');
                    // return dateFormatter(params.data.rs_effective_date);
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            //FOR RS
            rs_effective_date: {
                headerClass: "custom-ag-header",
                headerName: "Review Active Month",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Review Active Month"],
                    // headers: ["Active Call Date"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "rs_effective_date",
                    sortOrder: sortOrders["rs_effective_date"],
                    handleFilter,
                    handleSort,
                    showPopOver: true,
                    inputType: "select",
                    options: F.getMonths(),
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return F.getMonthFromDate(params.data.rs_effective_date, 'RS');
                    // return dateFormatter(params.data.rs_effective_date);
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },

            scheduleByDate: {
                headerClass: "custom-ag-header",
                headerName: "Schedule By Date",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Schedule By Date"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "expiration_date",
                    sortOrder: sortOrders["expiration_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "-";

                    const {
                        schedule_by_date,
                        expiration_date,
                        scheduled_by_date,
                    } = params.data;
                    const date = schedule_by_date || expiration_date || scheduled_by_date;

                    if (!date) return "-";

                    return moment(date).format("MM/DD/YYYY");
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            //FOR FS
            scheduled_by_date: {
                headerClass: "custom-ag-header",
                headerName: "Schedule By Date",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Schedule By Date"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "fs_expiration_date",
                    sortOrder: sortOrders["fs_expiration_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data || !params.data.scheduled_by_date) return "-";
                    return moment(params.data.scheduled_by_date)
                        .utc()
                        .format("MM/DD/YYYY");
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            expiration_date: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Schedule By Date"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "expiration_date",
                    sortOrder: sortOrders["expiration_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) =>
                    `${moment(params.data.expiration_date).format("MM/DD/YYYY hh:mmA")}`,
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            external_updated_on: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Submitted On"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "external_updated_on",
                    sortOrder: sortOrders["external_updated_on"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    const date = params.data && params.data.external_updated_on;
                    return dateFormatterUTC(date) || "-";
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            rs_scheduled_date: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Schedule By Date"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "expiration_date",
                    sortOrder: sortOrders["expiration_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                headerName: "Schedule By date",
                valueGetter: (params) =>
                    `${moment(params.data.expiration_date).format("MM/DD/YYYY hh:mmA")}`,
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            fs_scheduled_by_date: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Schedule By Date"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "fs_effective_date",
                    sortOrder: sortOrders["fs_effective_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                headerName: "Schedule By date",
                valueGetter: (params) => {
                    const date = params.data && params.data.fs_scheduled_by_date;
                    return dateFormatterUTC(date) || "-";
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            fs_effective_date: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    // headers: ["Active Call Date"],
                    headers: ["Follow Up Active Month"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "fs_effective_date",
                    sortOrder: sortOrders["fs_effective_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    // inputType: "date",
                    inputType: "select",
                    options: F.getMonths(),
                    handleFilterResetHandler,
                }),
                // headerName: "Schedule By date",
                headerName: "Follow Up Active Month",
                // valueGetter: (params) => {
                //     const date = params.data && params.data.fs_effective_date;
                //     return dateFormatterUTC(date) || "-";
                // },
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return F.getMonthFromDate(params.data.fs_effective_date, 'FS');
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            callAttempts: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Call Attempts"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "attempts",
                    // sortOrder: sortOrders["attempts"],
                    // handleSort
                    placeholder: TYPE_TO_FILTER_BY_ATTEMPTS,
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return params.data.call_attempts || params.data.attempts || "0";
                },
                sortable: false,
                filter: true,
                autoHeight: true,
            },
            userName: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Who Created"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "user_name",
                    // sortOrder: sortOrders["user_name"],
                    // handleSort
                    placeholder: TYPE_TO_FILTER_BY_WHO_CREATED,
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return `${params.data.user_name || ""} `;
                },
                sortable: false,
                filter: true,
                autoHeight: true,
            },
            rs_appointment_date: {
                headerClass: "custom-ag-header",
                headerName: "Appointment Date",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Appointment Date"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "rs_appointment_date",
                    sortOrder: sortOrders["rs_appointment_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return params.data.rs_appointment_date
                        ? formatDateWithCustomerTZ(
                            params.data.rs_appointment_date,
                            params.data.customer_timezone,
                        )
                        : "-";
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            rs_appointment_time: {
                headerClass: "custom-ag-header",
                headerName: "Appointment Time",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Appointment Time"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "rs_appointment_date",
                    placeholder: TYPE_TO_FILTER_BY_APPOINTMENT_TIME,
                    showPopOver: false,
                    inputType: "text",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    return F.formatAppointmentTime(
                        params.data.rs_appointment_date,
                        params.data.customer_timezone,
                    );
                },

                sortable: false,
                filter: false,
                autoHeight: true,
            },
            sub_type_of_call: {
                headerClass: "custom-ag-header",
                headerName: "Sub-Type",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => {
                    return {
                        headers: ["Sub-Type"],
                        colDef: params.column.getColDef(),
                        columnApi: params.columnApi,
                        field: "sub_type_of_call",
                        sortOrder: sortOrders["sub_type_of_call"],
                        handleSort,
                        handleFilter,
                        showPopOver: true,
                        inputType: "select",
                        options: F.getSubTypeOptionsByRole(card.role),
                        handleFilterResetHandler,
                    };
                },
                wrapText: true,
                width: 280,
                autoHeight: true,
                field: "sub_type_of_call",
                sortable: true,
                filter: true,
            },
            sub_type: {
                headerClass: "custom-ag-header",
                headerName: "Sub-Type",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => {
                    return {
                        headers: ["Sub Type"],
                        colDef: params.column.getColDef(),
                        columnApi: params.columnApi,
                        field: "sub_type_of_call",
                        handleFilter,
                        handleSort,
                        sortOrder: sortOrders["sub_type_of_call"],
                        inputType: "select",
                        options: F.getSubTypeOptionsByRole(card.role),
                        handleFilterResetHandler,
                    };
                },
                wrapText: true,
                width: 280,
                autoHeight: true,
                field: "sub_type",
                sortable: true,
                filter: true,
            },
            scheduled_with: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Scheduled With"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "bfile_user",
                    sortOrder: sortOrders["bfile_user"],
                    handleSort,
                    placeholder: TYPE_TO_FILTER_BY_SCHEDULE_WITH,
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    const user = params.data.bfile_user;
                    return user && user.first_name
                        ? `${user.first_name} ${user.last_name} `
                        : "-";
                },
                autoHeight: true,
                sortable: true,
                filter: true,
            },
            fs_appointment_date: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Appointment Date"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "von_appointment_date",
                    sortOrder: sortOrders["von_appointment_date"],
                    showPopOver: true,
                    inputType: "date",
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return params.data.appointment_date
                        ? formatDateWithCustomerTZ(
                            params.data.appointment_date,
                            params.data.customer_timezone,
                        )
                        : "-";
                },
                autoHeight: true,
                sortable: true,
                filter: true,
            },
            fs_appointment_time: {
                headerClass: "custom-ag-header",
                headerName: "Appointment Time",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Appointment Time"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "appointment_date",
                    showPopOver: false,
                    inputType: "text",
                    placeholder: TYPE_TO_FILTER_BY_APPOINTMENT_TIME,
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    return F.formatAppointmentTime(
                        params.data.appointment_date,
                        params.data.customer_timezone,
                    );
                },
                sortable: false,
                autoHeight: true,
            },
            //fs who created
            who_created: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Who Created"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    handleFilter,
                    field: "who_created",
                    // sortOrder: sortOrders["who_created"],
                    // handleSort
                    placeholder: TYPE_TO_FILTER_BY_WHO_CREATED,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                    defaultFilterContentWidth: 200,
                }),
                autoHeight: true,
                headerName: "Who Created",
                field: "who_created",
                sortable: false,
                filter: true,
            },
            claim_b_file: {
                headerClass: "custom-ag-header",
                headerName: "Action",
                field: "actions",
                width: 400,
                // cellRenderer: 'ButtonCellRenderer',
                // cellRendererParams: {
                //     onButtonClick: (buttonType, data) =>
                //         claim(index, data.id, moment(data.scheduled_by_date).format("YYYY-MM-DD")),
                //     buttonName: "Claim B File"
                // }
                cellRenderer: (params) => (
                    <Button
                        style={{ borderRadius: "20px" }}
                        type="primary"
                        className="bg-164897"
                        onClick={() =>
                            claim(
                                params.data.index,
                                params.data.id,
                                moment(params.data.scheduled_by_date)
                                    .utc()
                                    .format("YYYY-MM-DD"),
                            )
                        }
                    >
                        <Icon type="file-add" /> Claim B File
                    </Button>
                ),
            },
            full_name: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Scheduled With"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "full_name",
                    sortOrder: sortOrders["full_name"],
                    handleSort,
                    placeholder: TYPE_TO_FILTER_BY_SCHEDULE_WITH,
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                }),
                headerName: "Scheduled With",
                field: "full_name",
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            subTypeArray: {
                headerClass: "custom-ag-header",
                headerName: "Sub-Type",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => {
                    return {
                        headers: ["Sub Type"],
                        colDef: params.column.getColDef(),
                        columnApi: params.columnApi,
                        field: "sub_types",
                        handleFilter,
                        sortOrder: sortOrders["sub_types"],
                        handleSort,
                        showPopOver: true,
                        inputType: "select",
                        options: F.getSubTypeOptionsByRole(card.role),
                        handleFilterResetHandler,
                    };
                },
                wrapText: true,
                width: 280,
                autoHeight: true,
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return params.data.sub_types && params.data.sub_types.length > 0
                        ? getSubTypeNames(params.data.sub_types)
                        : "-";
                },
                colId: "sub_types",
                sortable: true,
                filter: true,
            },
            bfile_who_scheduled: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Scheduled With"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "bfile_user_full_name",
                    sortOrder: sortOrders["bfile_user_full_name"],
                    handleSort,
                    placeholder: TYPE_TO_FILTER_BY_SCHEDULE_WITH,
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return params.data.bfile_user_full_name
                        ? `${params.data.bfile_user_full_name}`
                        : "-";
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            appointment_date: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Appointment Date"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "appointment_date",
                    sortOrder: sortOrders["appointment_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return params.data.appointment_date
                        ? formatDateWithCustomerTZ(
                            params.data.appointment_date,
                            params.data.customer_timezone,
                        )
                        : "-";
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            appointment_time: {
                headerClass: "custom-ag-header",
                headerName: "Appointment Time",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Appointment Time"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "appointment_date",
                    placeholder: TYPE_TO_FILTER_BY_APPOINTMENT_TIME,
                    showPopOver: false,
                    inputType: "text",
                    handleFilterResetHandler,
                }),

                valueGetter: (params) => {
                    return F.formatAppointmentTime(
                        params.data.appointment_date,
                        params.data.customer_timezone,
                    );
                },
                sortable: false,
                filter: false,
                autoHeight: true,
            },
            rs_notreached_date: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Last Call Attempts"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "rs_notreached_date",
                    sortOrder: sortOrders["rs_notreached_date"],
                    handleFilter,

                    showPopOver: true,
                    inputType: "date",
                    handleSort,
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return params.data.rs_notreached_date
                        ? moment(params.data.rs_notreached_date).format("MM/DD/YYYY")
                        : "-";
                },
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            fs_notreached_date: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Last Call Attempts"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "fs_notreached_date",
                    sortOrder: sortOrders["fs_notreached_date"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "date",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    return params.data.fs_notreached_date
                        ? moment(params.data.fs_notreached_date).format("MM/DD/YYYY")
                        : "-";
                },
                sortable: true,
                filter: true,
                autoHeight: true,
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            sub_type: {
                headerClass: "custom-ag-header",
                headerName: "Sub-Type",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Sub-Type"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "sub_type_of_call",
                    handleFilter,
                    showPopOver: true,
                    sortOrder: sortOrders["sub_type_of_call"],
                    handleSort,
                }),
                wrapText: true,
                width: 280,
                autoHeight: true,
                field: "sub_type",
                sortable: true,
                filter: true,
            },
            scheduled_with: {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Scheduled With"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "bfile_user",
                    sortOrder: sortOrders["bfile_user"],
                    handleSort,
                }),
                valueGetter: (params) => {
                    if (!params.data) return "";
                    const user = params.data.bfile_user;
                    return user && user.first_name
                        ? `${user.first_name} ${user.last_name} `
                        : "-";
                },
            },
        };
    };

    const callFieldsRS = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "sub_type",
        "rs_effective_date",
        "callAttempts",
        "userName",
    ];

    const appointmentFieldsRS = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "sub_type_of_call",
        "rs_appointment_date",
        "rs_appointment_time",
        "callAttempts",
        "userName",
    ];

    const activeCallFieldsRS = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "sub_type_of_call",
        "rs_effective_date",
        "callAttempts",
        "rs_notreached_date",
        "userName",
    ];

    const upcomingCallFieldsRS = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "sub_type_of_call",
        "rs_effective_date",
        "callAttempts",
        "userName",
    ];

    const getDashboardColumnsRS = (dashboard_stats) => {
        switch (dashboard_stats) {
            case "due_calls":
            case "non_responsive_calls":
            case "not_interested":
            case "bad_phone_number":
            case "total_bad_phone_number":
            case "total_non_responsive":
                return callFieldsRS;

            case "requested_reschedules":
            case "appointments_scheduled":
                return appointmentFieldsRS;

            case "active_calls":
                return activeCallFieldsRS;

            case "upcoming_calls":
                return upcomingCallFieldsRS;

            case "office_appointments":
            case "phone_appointments":
            case "virtual_appointments":
            case "total_appointments":
            case "reschedule_appointments":
                return appointmentHistoryHistoricalDataFields;

            case "P&C Review":
            case "Commercial":
            case "Life Insurance":
            case "Retirement":
                return subTypeCallDataFields;

            case "total_call_attempts":
            case "dials_made":
            case "total_not_interested":
                return call_back_attempsFields;

            case "total_call_backs":
                return total_call_backs_RS_Fields;

            case "external_rac_files_count":
            case "external_rac_files_count_inactive_agencies":
                return rs_external_column_feilds;

            case "rs_queued_count":
                // case 'external_rac_files_count':
                return rs_queued_files_fields;
            default:
                return [];
        }
    };

    const getDashboardColumnsFS = (dashboard_stats) => {
        switch (dashboard_stats) {
            // Follow up Special Grid (Live Count)
            case "requested_reschedule":
            case "appointments_scheduled":
                return appointmentFieldsFS;

            case "upcoming_calls":
            case "due_calls":
            case "not_reached":
            case "non_responsive":
            case "not_interested":
            case "bad_phones_numbers":
            case "claimed_calls":
            case "bad_phone_number":
            case "non_responsive_calls":
            case "total_bad_phone_number":
            case "total_non_responsive":
                return callFollowUpFieldsFS;

            case "active_calls":
                return activeCallFieldsFS;

            // FS Admin Appointment (Historical)
            case "total_appointments":
            case "phone_appointments":
            case "virtual_appointments":
            case "office_appointments":
            case "reschedule_appointments":
            case "FollowUp":
            case "Prospect":
                return appointmentHistoryHistoricalDataFields;

            case "Thank You / Referrals":
            case "Life Insurance":
            case "Cross-Sell":
            case "Commercial":
            // case 'Prospect':
            case "Retirement":
            case "Re-Quote":
            case "Win Back":
            case "Event Call":
                return subTypeCallDataFields;

            case "total_call_attempts":
            case "dials_made":
            case "total_not_interested":
                return call_back_attempsFields;

            case "total_call_backs":
                return total_call_backs_FS_Fields;

            case "external_rac_files_count":
            case "external_rac_files_count_inactive_agencies":
                return fs_external_columns;

            case "queued_files":
            case "lead_queued_files":
            case "opportunity_queued_files":
                // case 'external_rac_files_count':
                return queued_files_fields;

            default:
                return [];
        }
    };

    const appointmentFieldsFS = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "sub_type_of_call",
        "fs_appointment_date",
        "fs_appointment_time",
        "callAttempts",
        "who_created",
    ];

    const callFollowUpFieldsFS = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "sub_type_of_call",
        "activeCallDate",
        // "scheduled_by_date",
        "callAttempts",
        "who_created",
        // ...(card && card.canClaimBFile ? ['claim_b_file'] : [])
    ];

    const activeCallFieldsFS = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "sub_type_of_call",
        "activeCallDate",
        // "scheduled_by_date",
        "callAttempts",
        "fs_notreached_date",
        "who_created",
        // ...(card && card.canClaimBFile ? ['claim_b_file'] : [])
    ];

    const appointmentHistoryHistoricalDataFields = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "subTypeArray",
        "appointment_date",
        "appointment_time",
        "bfile_who_scheduled",
        "who_created",
    ];

    const subTypeCallDataFields = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "sub_type_of_call",
        "appointment_date",
        "appointment_time",
        "bfile_who_scheduled",
        "who_created",
    ];

    const call_back_attempsFields = [
        "name",
        "phone",
        "agency",
        "typeOfCall",
        "sub_type_of_call",
        "who_created",
    ];

    const total_call_backs_FS_Fields = [
        "name",
        "phone",
        "agency",
        "fs_effective_date",
        // "fs_scheduled_by_date",
        "typeOfCall",
        "sub_type_of_call",
        "who_created",
    ];

    const total_call_backs_RS_Fields = [
        "name",
        "phone",
        "agency",
        "rs_effective_date",
        "typeOfCall",
        "sub_type_of_call",
        "who_created",
    ];

    const queued_files_fields = [
        "name",
        "phone",
        "agency",
        "fs_effective_date",
        // "fs_scheduled_by_date",
        "typeOfCall",
        "sub_type_of_call",
        "who_created",
    ];

    const fs_external_columns = [
        "name",
        "phone",
        "agency",
        "fs_effective_date",
        // "fs_scheduled_by_date",
        "typeOfCall",
        "sub_type_of_call",
        "external_updated_on",
        "who_created",
    ];

    const rs_queued_files_fields = [
        "name",
        "phone",
        "agency",
        "rs_effective_date",
        "typeOfCall",
        "sub_type_of_call",
        "who_created",
    ];

    const rs_external_column_feilds = [
        "name",
        "phone",
        "agency",
        "rs_effective_date",
        "typeOfCall",
        "sub_type_of_call",
        "external_updated_on",
        "who_created",
    ];

    const rsColumnDef = (columns, dashboard_stats) => {
        let columnDefs = [];
        const columnsToInclude = getDashboardColumnsRS(dashboard_stats) || [];
        columnDefs = columnsToInclude.map((item) => columns[item]);
        setColumnDefs(columnDefs);
    };

    const fsColumnDef = (columns, dashboard_stats) => {
        let columnDefs = [];
        const columnsToInclude = getDashboardColumnsFS(dashboard_stats) || [];
        columnDefs = columnsToInclude.map((item) => columns[item]);
        setColumnDefs(columnDefs);
    };

    const setAgenciesAndSyncSelection = (agencyList = []) => {
        const list = Array.isArray(agencyList) ? agencyList : [];
        setAgencies(list);

        const currentSelected = useBoundStore.getState().RSFSFilters.selectedAgency;
        if (currentSelected == null || currentSelected === "") {
            return;
        }

        const agencyStillAvailable = list.some(
            (agency) => Number(agency.id) === Number(currentSelected)
        );
        if (agencyStillAvailable) {
            return;
        }

        // Agency was filtered out (e.g. Calls Today set to NO) but persisted in store.
        setSelectedAgency(undefined);
        setRSFSFilters({
            selectedAgency: undefined,
            selectedAgencyName: undefined,
            page: 1,
        });
        setCurrentPage(1);
        getGridData();
    };

    const fetchRSAgenciesById = async (userId) => {
        try {
            const response = await axios.get(
                `${RS_DEDICATED_AGENCIES_API_URL_V2}/${userId}`,
            );
            const agencies = response.data.map((agency) => ({
                id: agency.agency_id,
                name: agency.agency_name,
            }));
            setAgenciesAndSyncSelection(agencies);
        } catch (err) {
            console.error("Error fetching agencies:", err);
        } finally {
        }
    };

    const fetchFSAgenciesById = async (userId) => {
        try {
            const response = await axios.get(`${VONBOARDER_AGENCIES_API_URL}`, {
                params: { user_type: VONBOARDER, user_id: userId },
            });
            setAgenciesAndSyncSelection(response.data);
        } catch (err) {
            console.error("Error fetching agencies:", err);
        } finally {
        }
    };

    const fetchRSAgencies = async () => {
        try {
            const response = await axios.get("/api/rs_user_agencies", {
                params: { user_type: REVIEWSCHEDULER },
            });
            setAgenciesAndSyncSelection(response.data);
        } catch (err) {
            console.error("Error fetching agencies:", err);
        } finally {
        }
    };

    const fetchAllRSAgencies = async () => {
        try {
            const response = await axios.get(RS_ALL_AGENCIES_API_URL);
            setAgenciesAndSyncSelection(response.data);
        } catch (err) {
            console.error("Error fetching agencies:", err);
        } finally {
        }
    };

    const fetchAllFSAgencies = async () => {
        try {
            const response = await axios.get(GET_FS_ALL_AGENCIES);
            setAgenciesAndSyncSelection(response.data);
        } catch (err) {
            console.error("Error fetching agencies:", err);
        } finally {
        }
    };

    const fetchAgents = async (searchText) => {
        setFetching(true);
        try {
            let url = AGENT_SEARCH_API_URL;
            if (searchText) {
                url += `?user_search=${encodeURIComponent(searchText)}`;
            }
            const response = await axios.get(url);
            const agentsList = Array.isArray(response.data.results)
                ? response.data.results
                : [];
            setAgents(agentsList);
        } catch (error) {
            console.error("Error fetching agents:", error);
        } finally {
            setFetching(false);
        }
    };

    const fetchAgentsByAgencyId = async (agencyId) => {
        setLoading(true);
        try {
            const params = {};
            if (agencyId) {
                params.agency_id = agencyId;
            }
            const response = await axios.get(AGENT_SEARCH_API_URL, { params });
            const agentsList =
                response.data && response.data.results ? response.data.results : [];
            setAgents(agentsList);
        } catch (err) {
            console.error("Error fetching agencies:", err);
            setAgents([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchFSAgencies = async () => {
        try {
            const response = await axios.get(VONBOARDER_AGENCIES_API_URL, {
                params: { user_type: VONBOARDER },
            });
            setAgenciesAndSyncSelection(response.data);
        } catch (err) {
            console.error("Error fetching agencies:", err);
        } finally {
        }
    };


    const selectAgency = (value) => {
        setCurrentPage(1);

        if (card.hasAgentDropDown) {
            fetchAgentsByAgencyId(value);
        }

        setSelectedAgency(value);

        const dateRange = getDefaultDateRange(agencies, value);

        setRSFSFilters({
            selectedAgency: value,
            datemodified: dateRange,
            page: 1,
        });

        setdatemodified(dateRange);
        setSelectedAgent([]);
        getGridData();
    };

    // const selectAgency = (value) => {
    //     setCurrentPage(1);
    //     if (card.hasAgentDropDown) {
    //         fetchAgentsByAgencyId(value);
    //     }
    //     setSelectedAgency(value);
    //     setRSFSFilters({ selectedAgency: value, page: 1 });
    //     getGridData();
    //     setSelectedAgent([]);
    // };

    const debouncedFetchAgents = debounce(async (searchText) => {
        setFetching(true);
        try {
            const params = {};
            if (searchText) {
                params.user_search = searchText.trim();
            }
            if (RSFSFilters.selectedAgency) {
                params.agency_id = RSFSFilters.selectedAgency;
            }
            const response = await axios.get(AGENT_SEARCH_API_URL, { params });
            const agentsList =
                response.data && response.data.results ? response.data.results : [];
            setAgents(agentsList);
        } catch (error) {
            console.error("Error fetching agents:", error);
        } finally {
            setFetching(false);
        }
    }, 500);

    const selectAgent = (selectedAgents) => {
        setCurrentPage(1);
        setRSFSFilters({ selectedAgent: selectedAgents, page: 1 });
        setSelectedAgent(selectedAgents);
        getGridData();
    };

    const rsApiFilter = (sec, changePage = false) => {
        let api;
        const card = JSON.parse(localStorage.getItem("card"));
        if (card.isRSAdmin && card.isHistoricalGrid) {
            api = getHistoricalGridApi(card.dashboard_stats);
            let dashboard_stats = card.dashboard_stats;
            if (api) {
                loadBucketForHistorical({ ind: sec, api, dashboard_stats });
            }
        } else {
            api = card.isRSAdmin ? GET_RS_ADMIN_CALL_DATA : apiMapForRS[sec];
            if (card.dashboard_stats == "dials_made") {
                api = RS_DIALS_MADE_GRID;
            }
            if (api) {
                loadBucketForRS({ ind: sec, api, changePage });
            }
        }
    };

    const prepareApiFilterForFS = ({ sec, changePage = false } = {}) => {
        let api;
        const card = JSON.parse(localStorage.getItem("card"));
        if (card.isFSAdmin && card.isHistoricalGrid) {
            api = getHistoricalGridApi(card.dashboard_stats);
            let dashboard_stats = card.dashboard_stats;
            if (api) {
                loadBucketForHistorical({ ind: sec, api, dashboard_stats });
            }
        } else {
            api = card.isFSAdmin ? GET_FS_ADMIN_GRID_DATA : apiMapForFS[sec];
            if (card.dashboard_stats == "dials_made") {
                api = FS_DIALS_MADE_GRID;
            }
            if (api) {
                loadBucketForFS({ ind: sec, api, changePage });
            }
        }
    };

    const getGridRows = (responseData) => {
        if (Array.isArray(responseData.data)) return responseData.data;
        if (Array.isArray(responseData.objects)) return responseData.objects;
        return [];
    };

    const loadBucketForHistorical = async ({
        ind,
        api,
        dashboard_stats,
    } = {}) => {
        const card = JSON.parse(localStorage.getItem("card"));
        setLoading(true);
        let params = {};

        const filterStore = useBoundStore.getState().RSFSFilters;
        const filterStoreCard = useBoundStore.getState().RSFSCardFilters;

        if (dashboard_stats) {
            if (dashboard_stats == "phone_appointments") {
                params.location = "Phone";
            } else if (dashboard_stats == "office_appointments") {
                params.location = "Office";
            } else if (dashboard_stats == "virtual_appointments") {
                params.location = "Virtual";
            } else if (
                dashboard_stats == "FollowUp" ||
                dashboard_stats == "Prospect"
            ) {
                params.type_of_call = dashboard_stats;
            } else if (card.isSubTypeOfCall) {
                params.sub_type_of_call = dashboard_stats;
            } else if (dashboard_stats == "reschedule_appointments") {
                params.reschedule = true;
            }
        }

        if (filterStore.selectedAgency)
            params.agency_id = filterStore.selectedAgency;
        if (filterStore.searchText) params.search = filterStore.searchText.trim();
        if (filterStore.hideBadPhoneNumber) {
            if (
                card.title != "Bad Phone Numbers" &&
                card.title != "Bad Phone Number"
            ) {
                params.bad_phone_number_status = !filterStore.hideBadPhoneNumber;
            }
        }
        if (filterStore.selectedFilterOption) {
            let type_of_call =
                filterStore.selectedFilterOption == "AllBFiles"
                    ? null
                    : filterStore.selectedFilterOption;
            if (type_of_call) {
                params.type_of_call = type_of_call;
            }
        }

        // if (card.hasAgentDropDown && filterStore.selectedAgent) {
        //     params.agenct_id = params.agenct_id;
        // }
        if (filterStore.datemodified.start_date)
            params.start_date = formatDate(filterStore.datemodified.start_date);
        if (filterStore.datemodified.end_date)
            params.end_date = formatDate(filterStore.datemodified.end_date);
        if (filterStore.field && filterStore.direction) {
            params.sort_by = filterStore.field;
            params.sort_order = filterStore.direction;
            // params.sort = `${filterStore.field}:${filterStore.direction}`;
        }
        // if (filterStore.hideBadPhoneNumber) {
        //     params.bad_phone_number_status = !filterStore.hideBadPhoneNumber;
        // }
        if (filterStore.page) {
            params.page = filterStore.page;
        }
        // if (filterStore.userType) {
        //     params.user_type = filterStore.userType;
        // }
        if (card.isRSAdmin || card.isFSAdmin) {
            params.toggle_user_type = card.isRSAdmin ? REVIEWADMIN : BOBADMIN;
            if (card.user_id || filterStoreCard.selectedUserId) {
                params.scheduler_specialist_id =
                    card.user_id || filterStoreCard.selectedUserId;
            }
            //params.grid_type = card.dashboard_stats
        }
        if (
            filterStore.filter_by_column_name &&
            Object.keys(filterStore.filter_by_column_name).length > 0
        ) {
            params.filter_by_column_name = JSON.stringify(
                filterStore.filter_by_column_name,
            );
        }

        const queryParts = [];

        queryParts.push(new URLSearchParams(params).toString());

        if (filterStore.selectedAgent && filterStore.selectedAgent.length > 0) {
            const userIdsQuery = filterStore.selectedAgent
                .map((u) => `bfile_user_id=${u}`)
                .join("&");
            queryParts.push(userIdsQuery);
        }

        if (
            filterStore.filter_by_column_name &&
            Object.keys(filterStore.filter_by_column_name).length > 0 &&
            Object.values(filterStore.filter_by_column_name).length > 0
        ) {
            params.filter_by_column_name = JSON.stringify(
                filterStore.filter_by_column_name,
            );
        }
        const queryString = queryParts.filter(Boolean).join("&");
        const url = `${api}?${queryString}`;

        try {
            const res = await axios.get(url);

            if (res.data.data.length > 0) {
                if (gridApi) {
                    gridApi.setRowData(res.data.data);
                }
                setTotalPages(res.data.pages);
                setRowData(res.data.data);
            } else {
                setRowData([]);
                setTotalPages(res.data.pages);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const loadBucketForRS = async ({ ind, api, changePage = false } = {}) => {
        const card = JSON.parse(localStorage.getItem("card"));
        setLoading(true);
        let params = {};

        const filterStore = useBoundStore.getState().RSFSFilters;
        const filterStoreCard = useBoundStore.getState().RSFSCardFilters;

        if (filterStore.selectedAgency)
            params.agency_id = filterStore.selectedAgency;
        if (filterStore.searchText) params.search = filterStore.searchText.trim();
        if (filterStore.selectedFilterOption) {
            let type_of_call =
                filterStore.selectedFilterOption == "AllBFiles"
                    ? null
                    : filterStore.selectedFilterOption;
            if (type_of_call) {
                params.type_of_call = type_of_call;
            }
        }
        if (card.hasAgentDropDown && filterStore.selectedAgent) {
            params.agenct_id = filterStore.selectedAgent;
        }
        if (filterStore.datemodified.start_date)
            params.start_date = formatDate(filterStore.datemodified.start_date);
        if (filterStore.datemodified.end_date)
            params.end_date = formatDate(filterStore.datemodified.end_date);
        if (filterStore.field && filterStore.direction) {
            params.sort = `${filterStore.field}:${filterStore.direction}`;
        }
        if (filterStore.hideBadPhoneNumber) {
            if (
                card.title != "Bad Phone Numbers" &&
                card.title != "Bad Phone Number"
            ) {
                params.bad_phone_number_status = !filterStore.hideBadPhoneNumber;
            }
        }
        if (changePage === true && filterStore.page) {
            if (filterStore.hideBadPhoneNumber) {
                if (
                    card.title != "Bad Phone Numbers" &&
                    card.title != "Bad Phone Number"
                ) {
                    params.bad_phone_number_status = !filterStore.hideBadPhoneNumber;
                }
            }
            params.page = filterStore.page;
        }
        if (filterStore.userType) {
            params.user_type = filterStore.userType;
        }
        if (card.isRSAdmin) {
            params.user_type = REVIEWADMIN;
            if (card.user_id || filterStoreCard.selectedUserId) {
                params.user_id = card.user_id || filterStoreCard.selectedUserId;
            }
            if (card.dashboard_stats == "total_non_responsive") {
                params.grid_type = "non_responsive_calls";
            } else {
                params.grid_type = card.dashboard_stats;
            }
        }
        // if (card.dashboard_stats === 'external_rac_files_count') {
        //     params.grid_type = (card.role === REVIEWSCHEDULER) ? REVIEW : FOLLOWUP;
        // }

        if (
            filterStore.filter_by_column_name &&
            Object.keys(filterStore.filter_by_column_name).length > 0 &&
            Object.values(filterStore.filter_by_column_name).length > 0
        ) {
            params.filter_by_column_name = JSON.stringify(
                filterStore.filter_by_column_name,
            );
        }
        const queryString = new URLSearchParams(params).toString();
        const url = `${api}?${queryString}`;

        try {
            const res = await axios.get(url);

            const rows = getGridRows(res.data);
            if (rows.length > 0) {
                if (gridApi) {
                    gridApi.setRowData(rows);
                }
                setTotalPages(res.data.total_pages);
                setRowData(rows);
            } else {
                setRowData([]);
                setTotalPages(res.data.total_pages);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const loadBucketForFS = async ({ ind, api, changePage = false } = {}) => {
        const card = JSON.parse(localStorage.getItem("card"));
        const hasFollowUp = roles.includes("FollowUp");
        const hasProspect = roles.includes("Prospect");

        let role = null;
        if (hasFollowUp && !hasProspect) {
            role = "FollowUp";
        } else if (!hasFollowUp && hasProspect) {
            role = "Prospect";
        }

        setLoading(true);

        let params = {};
        let type_of_call;
        const filterStore = useBoundStore.getState().RSFSFilters;
        const filterStoreCard = useBoundStore.getState().RSFSCardFilters;

        if (filterStore.selectedAgency)
            params.agency_id = filterStore.selectedAgency;
        if (filterStore.searchText)
            params.search_param = filterStore.searchText.trim();
        if (filterStore.selectedFilterOption) {
            if (role) {
                type_of_call = role;
            } else {
                type_of_call =
                    filterStore.selectedFilterOption == "AllBFiles"
                        ? null
                        : filterStore.selectedFilterOption;
            }
            if (type_of_call) {
                params.type_of_call = type_of_call;
            }
        }
        if (filterStore.hideBadPhoneNumber) {
            if (
                card.title != "Bad Phone Numbers" &&
                card.title != "Bad Phone Number"
            ) {
                params.bad_phone_number_status = !filterStore.hideBadPhoneNumber;
            }
        }
        if (filterStore.datemodified.start_date)
            params.from = filterStore.datemodified.start_date;
        if (filterStore.datemodified.end_date)
            params.to = filterStore.datemodified.end_date;
        if (filterStore.field && filterStore.direction) {
            params.order_by = JSON.stringify([
                { field: filterStore.field, direction: filterStore.direction },
            ]);
        }
        if (changePage === true && filterStore.page) {
            params.page = filterStore.page;
        }

        if (card.isFSAdmin) {
            params.user_type = BOBADMIN;
            if (card.user_id || filterStoreCard.selectedUserId) {
                params.user_id = card.user_id || filterStoreCard.selectedUserId;
            }
            if (card.dashboard_stats == "total_non_responsive") {
                params.grid_type = "non_responsive_calls";
            } else {
                params.grid_type = card.dashboard_stats;
            }
        }

        // if (card.dashboard_stats === 'external_rac_files_count') {
        //     params.grid_type = (card.role === REVIEWSCHEDULER) ? REVIEW : FOLLOWUP;
        // } else
        if (
            ["lead_queued_files", "opportunity_queued_files"].includes(
                card.dashboard_stats,
            )
        ) {
            params.grid_type =
                card.dashboard_stats === "lead_queued_files"
                    ? "lead_queued_bfiles"
                    : card.dashboard_stats;
        }

        if (
            filterStore.filter_by_column_name &&
            Object.keys(filterStore.filter_by_column_name).length > 0 &&
            Object.values(filterStore.filter_by_column_name).length > 0
        ) {
            params.filter_by_column_name = JSON.stringify(
                filterStore.filter_by_column_name,
            );
        }

        const queryString = new URLSearchParams(params).toString();
        const url = `${api}?${queryString}`;

        try {
            const res = await axios.get(url);

            const rows = getGridRows(res.data);
            if (rows.length > 0) {
                setRowData(rows);
                setTotalPages(res.data.total_pages);
            } else {
                setRowData([]);
                setTotalPages(res.data.total_pages);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        return new Date(date).toISOString().split("T")[0];
    };

    // Format date in customer's timezone (IANA tz string in customer_timezone)
    const formatDateWithCustomerTZ = (inputDate, timeZone) => {
        if (!inputDate) return "-";
        try {
            const dateObj = new Date(inputDate);
            return dateObj.toLocaleDateString("en-US", {
                timeZone: timeZone || undefined,
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
            });
        } catch (e) {
            // Fallbacks
            if (timeZone) {
                // If invalid tz, at least show UTC formatted date
                return moment.utc(inputDate).format("MM/DD/YYYY");
            }
            return moment(inputDate).format("MM/DD/YYYY");
        }
    };

    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
        setColumnApi(params.columnApi);

        // restore saved column state if present
        const savedState = localStorage.getItem("agGridColumnState");
        if (savedState) {
            params.columnApi.applyColumnState({
                state: JSON.parse(savedState),
                applyOrder: true,
            });
        }
    }, []);

    const saveState = useCallback((params) => {
        const state = params.columnApi.getColumnState();
        localStorage.setItem("agGridColumnState", JSON.stringify(state));
    }, []);

    const goTo = (path) => {
        props.history.push({
            pathname: path,
        });
    };

    const CreatePhoneCellRenderer = React.forwardRef((params, ref) => {
        const bfile = params.data;

        if (!bfile || !bfile.phone) return <span ref={ref}>-</span>;

        return (
            <div ref={ref} style={{ display: "flex", alignItems: "center" }}>
                {/* Click-to-call link */}
                <a href={`tel:${bfile.phone}`} className="phone-link">
                    {F.phone_format(bfile.phone)}
                </a>

                {/* Copy icon */}
                <Tooltip
                    title="Copy phone number"
                    getPopupContainer={() => document.body}
                >
                    <Icon
                        type="copy"
                        style={{
                            marginLeft: 8,
                            cursor: "pointer",
                            fontSize: "14px",
                            color: "#1890ff",
                        }}
                        onClick={() => F.handleCopyClick(bfile.phone)}
                    />
                </Tooltip>
            </div>
        );
    });

    const CreateNameRendererRS = React.forwardRef((params, ref) => {
        const bfile = params.data;

        if (!bfile) return null;

        const showBN = bfile.bad_phone_number_status === 1;
        const highPriorityValue = bfile.high_priority;
        const isHighPriority =
            highPriorityValue === true ||
            highPriorityValue === 1 ||
            String(highPriorityValue).toLowerCase() === "high" ||
            String(highPriorityValue).toLowerCase() === "true";

        let bFileId = card.isHistoricalGrid ? bfile.bfile_id : bfile.id;

        return (
            <div ref={ref} style={{ alignItems: "center", display: "flex" }}>
                <Icon type="user" style={{ marginRight: 10, color: "#666" }} />
                <a
                    className="custom-link"
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        goTo("/customer/" + bFileId);
                    }}
                >
                    {bfile.first_name} {bfile.last_name}
                </a>
                {showBN && <BadNumberTooltip />}
                {isHighPriority && (
                    <Tooltip
                        title="High Priority"
                        getPopupContainer={() => document.body}
                    >
                        <Icon
                            type="warning"
                            theme="filled"
                            style={{
                                color: "#e8194f",
                                cursor: "default",
                                fontSize: 16,
                                marginLeft: 8,
                            }}
                        />
                    </Tooltip>
                )}
            </div>
        );
    });

    const parseIntAdv = (str) => {
        if (typeof str === "string" && str.trim() !== "") {
            return parseInt(str, 10); // Specifying base 10
        }
        return 0;
    };

    const handleButtonClick = (buttonType, data) => {
        if (buttonType === "button1") {
            view(data.id);
        } else if (buttonType === "button2") {
            //// .log('Button 2 clicked');
            sendNotification(data);
        }
    };

    const viewClick = (buttonType, data) => {
        if (buttonType === "View") {
            view(data.id);
        } else if (buttonType == "Delete") {
            deleteBFile(data.id);
        } else if (buttonType == "Complete/Archive") {
            completeArchive(data.id);
        } else if (buttonType == "appointmentModal") {
            setAppointmentModal(true);
            setSelectRowData(data);
        } else if (buttonType == "sendNotification") {
            sendNotification(data);
        }
    };

    const dateFormatter = (date) => {
        if (date) {
            return moment(date).format("MM/DD/YYYY") || "";
        } else {
            return "";
        }
    };

    const dateFormatterUTC = (date) => {
        if (date) {
            return moment.utc(date).format("MM/DD/YYYY") || "";
        } else {
            return "";
        }
    };


    const claim = async (ind, bfile_id, expiration_date) => {
        setLoading(true);

        try {
            await axios.put(`/api/b_file/${bfile_id}`, {
                archive: 0,
                not_interested: 0,
                onboarding_id: userId,
                expiration_date: expiration_date,
                vo_claim_date: moment()
                    .utc()
                    .format("YYYY-MM-DD HH:mm:ss"),
            });

            props.history.push(`/customer/${bfile_id}`);
        } catch (error) {
            console.error("Error updating b_file:", error);
        } finally {
            setLoading(false);
        }
    };

    const deleteBFile = (bfile_id) => {
        axios
            .put(`/api/b_file/${bfile_id}`, { deleted: 1 })
            .then(() => { })
            .catch((error) => {
                //// .error("Error deleting B File:", error);
            });
    };

    const view = (bfile_id) => {
        props.history.push("/customer/" + bfile_id);
    };

    const completeArchive = (bfile_id) => {
        axios
            .put(`/api/b_file/${bfile_id}`, { rs_archived: 1 })
            .then(() => { })
            .catch((error) => {
                //// .error("Error completing B File:", error);
            });
    };
    const complete = (bfile) => {
        const { user } = props.auth.user;
        const bfile_id = bfile.id;
        const notInterestedPayload = {
            vob_archived: 1,
        };

        axios.put("/api/b_file/" + bfile_id, notInterestedPayload).then(() => { });

        axios.post("/api/bfile_notes", {
            bfile_id: bfile.id,
            note: "Not interested.",
            user_id: user.id,
            action: "Complete",
        });
    };

    const handleRoleChange = (newRole) => {
        useBoundStore.getState().setRSFSCardFilters({
            selectedToggle: newRole,
            selectedToggleAPI: newRole,
            selectedAdminToggle: newRole,
            selectedButton: "AllBFiles",
            selectedAgency: undefined,

            dateRangeAdminFilter: 1,
            showLeaderBoardGrid: false,
            selectedLeaderBoardAgency: undefined,
            selectedLeaderBoardUsers: [],
            datemodified: {
                start_date: "2010-01-01",
                end_date: "2050-01-01",
            },
        });
        props.history.push("/dashboard");
    };



    const handleRangeChange = (dates) => {
        setRSFSFilters({
            selectedButton: 'None'
        });

        setSelectedButton('None');

        const start = dates && dates[0]
            ? moment(dates[0]).format("YYYY-MM-DD")
            : null;

        const end = dates && dates[1]
            ? moment(dates[1]).format("YYYY-MM-DD")
            : null;

        setdatemodified((prev) => {

            const updatedStartDate = start;
            const updatedEndDate = end;

            setRSFSFilters({
                datemodified: {
                    start_date: updatedStartDate,
                    end_date: updatedEndDate,
                },
            });


            if (updatedStartDate && updatedEndDate) {
                getGridData();
            }

            return {
                ...prev,
                start_date: updatedStartDate,
                end_date: updatedEndDate,
            };
        });
    };

    const handleDateChange = (date, dateType) => {
        setRSFSFilters({
            selectedButton: "None",
        });

        setSelectedButton("None");

        const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;

        setdatemodified((prev) => {
            const updatedStartDate =
                dateType === "start_date" ? formattedDate : prev.start_date;
            const updatedEndDate =
                dateType === "end_date" ? formattedDate : prev.end_date;

            setRSFSFilters({
                datemodified: {
                    start_date: updatedStartDate,
                    end_date: updatedEndDate,
                },
            });

            if (updatedStartDate && updatedEndDate) {
                getGridData();
            }

            return {
                ...prev,
                start_date: updatedStartDate,
                end_date: updatedEndDate,
            };
        });
    };

    const handleAllBFiles = () => {
        const dateRange = getDefaultDateRange(agencies, selectedAgency);

        setSelectedButton("AllBFiles");

        setRSFSFilters({
            datemodified: dateRange,
            selectedButton: "AllBFiles",
        });

        setdatemodified(dateRange);

        getGridData();
    };

    // const handleAllBFiles = () => {
    //     const startOfMonth = "2010-01-01";
    //     const endOfMonth = "2050-01-01";
    //     setSelectedButton("AllBFiles");
    //     setRSFSFilters({
    //         datemodified: {
    //             start_date: startOfMonth,
    //             end_date: endOfMonth,
    //         },
    //         selectedButton: "AllBFiles",
    //     });

    //     getGridData();

    //     setdatemodified((prev) => {
    //         return {
    //             ...prev,
    //             start_date: startOfMonth,
    //             end_date: endOfMonth,
    //         };
    //     });
    // };

    const handleThisMonth = () => {
        const startOfMonth = moment()
            .startOf("month")
            .format("YYYY-MM-DD");
        const endOfMonth = moment()
            .endOf("month")
            .format("YYYY-MM-DD");
        setSelectedButton("ThisMonth");

        setRSFSFilters({
            datemodified: {
                start_date: startOfMonth,
                end_date: endOfMonth,
            },
            selectedButton: "ThisMonth",
        });

        getGridData();

        setdatemodified((prev) => {
            return {
                ...prev,
                start_date: startOfMonth,
                end_date: endOfMonth,
            };
        });
    };

    const sendNotification = async (bfile) => {
        if (!bfile) return;
        F.log("BFILE =>", bfile);

        try {
            const res = await axios.post(
                "/api/get_all_user_for_bad_phone_number_notification",
                {
                    agency_id: bfile.agency_id,
                },
            );

            F.log("Res.data =>", res.data.data);

            if (res.data.data.length) {
                let data = {
                    notification_message: `The phone number for ${bfile.first_name}, ${bfile.last_name} is not valid. Please update it.`,
                    user_ids: res.data.data,
                    severity: "low",
                    dispatch_time: Math.floor(Date.now() / 1000),
                    bfile_id: bfile.id,
                };

                await axios.post("/api/create_notification", data);
                F.log("Notification Sent Successfully");
                message.success(F.translate("Notification Sent Successfully"));
            } else {
                message.info(F.translate("No Users to Notify"));
            }
        } catch (error) {
            message.error(F.translate("Failed to send notification"));
        }
    };

    const showAllBFilesButton = () => {
        const zustandState = useBoundStore.getState().RSFSCardFilters;
        let selectedToggleAPI = zustandState.selectedToggleAPI;
        const hasFollowUp = roles.includes("FollowUp");
        const hasProspect = roles.includes("Prospect");
        const hasReview = roles.includes("Review");
        if (
            selectedToggleAPI === REVIEWSCHEDULER ||
            selectedToggleAPI == REVIEWADMIN
        ) {
            return true;
        }

        if (selectedToggleAPI === VONBOARDER || selectedToggleAPI == EA) {
            return !(hasFollowUp && hasProspect);
        }
        return false;
    };

    const showSelectionFilterOptionDropdown = () => {
        const zustandState = useBoundStore.getState().RSFSCardFilters;
        let selectedToggleAPI = zustandState.selectedToggleAPI;
        const hasFollowUp = roles.includes("FollowUp");
        const hasProspect = roles.includes("Prospect");
        return selectedToggleAPI === VONBOARDER && hasFollowUp && hasProspect;
    };

    const routeToRSFSGrid = (item, userName) => {
        if (item.isClickable) {
            setRSFSFilters({ selectedAgent: [] });
            setSelectedAgent([]);
            setAgents([]);
            setSearchText("");
            setCurrentPage(1);
            handleCloseModal();
            handleQuickNavigationModalClose();
            setRSFSFilters({ searchText: "", page: 1 });
            item.userName = userName;
            localStorage.setItem("card", JSON.stringify(item));
            setRSFSFilters({ newTitle: item.dashboard_stats });
            // console.log(item);
            setGridKey((prev) => prev + 1);
            props.history.push({
                pathname: "/dashboard/rsfs-grid",
                search: `?title=${encodeURIComponent(item.title)}`,
                state: { card: item },
            });
            // Also force columns recalculation
            prepareGridColumn();

            const { newTitle, previousTitle } = useBoundStore.getState().RSFSFilters;
            if (newTitle == previousTitle) {
                getRSFSGridDataOnNavigation();
            }
        }
    };

    const handleBackToDashboard = () => {
        setSortOrders({});
        setRSFSFilters({
            filter: "",
            direction: "",
        });
        props.history.push("/dashboard");
    };

    return (
        <div>
            {card && card.back_to_dashboard && (
                <div
                    role="button"
                    tabIndex="0"
                    style={{ marginBottom: "10px" }}
                    className="hyperlink-shomore-stat"
                    onClick={handleBackToDashboard}
                    onMouseEnter={(e) =>
                        (e.currentTarget.style.textDecoration = "underline")
                    }
                    onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleBackToDashboard();
                        }
                    }}
                >
                    <Icon type="arrow-left" />
                    Back to Dashboard
                </div>
            )}

            <CommonHeader
                user={props.auth.user}
                onRoleChange={handleRoleChange}
                isHidden={false}
            />
            <div className="rsfs-filters-mobile">
                <div
                    className="inlineButton"
                    style={{ marginTop: "25px", gap: "10px" }}
                >
                    <div
                        style={{ display: "flex", justifyContent: "start", gap: "10px" }}
                    >
                        <div style={{ display: "flex", gap: "10px", position: "relative" }}>
                            {// (card.role == REVIEWSCHEDULER)
                                showAllBFilesButton() && (
                                    <Button
                                        className={
                                            selectedButton === "AllBFiles" || !selectedButton
                                                ? "bgPrimary"
                                                : "bgGray"
                                        }
                                        onClick={handleAllBFiles}
                                    >
                                        All B Files
                                    </Button>
                                )}

                            {// (card.role == VONBOARDER)
                                showSelectionFilterOptionDropdown() && (
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "5px",
                                            width: "100%",
                                            "@media (max-width: 768px)": {
                                                width: "100%",
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear
                                            showSearch
                                            className="dropDown custom-select custom-roles-filter"
                                            placeholder="Select Filter"
                                            optionFilterProp="children"
                                            onChange={onFilterChange}
                                            filterOption={(input, option) =>
                                                option.props.children &&
                                                option.props.children
                                                    .toLowerCase()
                                                    .includes(input.toLowerCase())
                                            }
                                            value={selectedFilterOption}
                                            style={{
                                                width: "100%",
                                                "@media (max-width: 768px)": {
                                                    width: "100%",
                                                },
                                            }}
                                        >
                                            {filterOptions.map((opt) => (
                                                <Option
                                                    key={opt.id}
                                                    value={opt.key}
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    {opt.value}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                )}

                            <Button
                                className={
                                    selectedButton === "ThisMonth" ? "bgPrimary" : "bgGray"
                                }
                                value={period}
                                onClick={() => handleThisMonth()}
                            >
                                This Month
                            </Button>
                        </div>

                        <div
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                position: "relative",
                                width: "200px",
                            }}
                        >
                            <Input
                                className="dropDown search-name-input"
                                placeholder="Search File"
                                value={searchText}
                                onChange={handleSearch}
                            />
                            {searchText ? (
                                <Icon
                                    type="close"
                                    onClick={() => handleSearch({ target: { value: "" } })}
                                    style={{ right: windowWidth <= 769 ? "10px" : "30px" }}
                                    className="icon-style"
                                />
                            ) : (
                                <Icon
                                    type="search"
                                    style={{ right: windowWidth <= 769 ? "10px" : "30px" }}
                                    className="icon-style"
                                />
                            )}
                        </div>
                        <div style={{ position: "relative" }}>
                            <Select
                                allowClear
                                showSearch
                                className="dropDown custom-select"
                                placeholder="Search By Agency"
                                optionFilterProp="children"
                                onChange={selectAgency}
                                filterOption={(input, option) =>
                                    option.props.children &&
                                    option.props.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                value={selectedAgency}
                            >
                                {agencies.map((opt) => (
                                    <Option
                                        key={opt.id}
                                        value={opt.id}
                                        style={{ fontSize: "12px" }}
                                    >
                                        {opt.name}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>

                    <div
                        className="datepicker-rsfs"
                        style={{ marginTop: "-20px" }}
                    >
                        <Row style={{ display: "flex", gap: "25px" }}>
                            <Col span={16}>
                                <div className="datepicker-label-rsfs" style={{ visibility: 'hidden' }}>Select Date Range</div>
                                <DatePicker.RangePicker
                                    style={{ width: 300 }}
                                    dropdownClassName="custom-range-picker" //for header
                                    open={open}
                                    // onOpenChange={(status) => setOpen(status)}
                                    onOpenChange={(status) => {
                                        if (!status) return;
                                        setOpen(true);
                                    }}
                                    value={[
                                        datemodified.start_date ? moment(datemodified.start_date) : null,
                                        datemodified.end_date ? moment(datemodified.end_date) : null
                                    ]}
                                    format={dateFormat}
                                    onChange={(dates) => {
                                        if (dates && dates.length === 2) {
                                            const start = dates[0].format("YYYY-MM-DD");
                                            const end = dates[1].format("YYYY-MM-DD");
                                            setdatemodified(prev => ({
                                                ...prev,
                                                start_date: start,
                                                end_date: end
                                            }));
                                            setOpen(true);
                                        }
                                    }}
                                    renderExtraFooter={() => {
                                        const start = datemodified.start_date
                                            ? moment(datemodified.start_date)
                                            : moment();

                                        const end = datemodified.end_date
                                            ? moment(datemodified.end_date)
                                            : moment();

                                        return (
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between', gap: 20
                                            }}>

                                                {/* START CONTROLS */}
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                                    <div style={{ fontSize: 12, marginBottom: '-7px' }}>Start</div>

                                                    <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                                                        <Select
                                                            showSearch
                                                            value={start.month()}
                                                            style={{ width: 100 }}
                                                            // className="dateRangedropDown custom-select"
                                                            onChange={(month) => {
                                                                const newDate = start.clone().month(month);
                                                                setdatemodified(prev => ({
                                                                    ...prev,
                                                                    start_date: newDate,
                                                                }));
                                                            }}
                                                            filterOption={(input, option) =>
                                                                option.props.children &&
                                                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                            }
                                                        >
                                                            {F.getMonthNames().map((m, i) => (
                                                                <Option key={i} value={i}>{m}</Option>
                                                            ))}
                                                        </Select>

                                                        <Select
                                                            showSearch
                                                            value={start.year()}
                                                            // className="dateRangedropDown custom-select"
                                                            style={{ width: 80 }}
                                                            onChange={(year) => {
                                                                const newDate = start.clone().year(year);
                                                                setdatemodified(prev => ({
                                                                    ...prev,
                                                                    start_date: newDate,
                                                                }));
                                                            }}
                                                            filterOption={(input, option) =>
                                                                option.props.children &&
                                                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                            }
                                                        >
                                                            {F.getYears().map((y) => (
                                                                <Option key={y} value={y}>{y}</Option>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                </div>

                                                {/* END CONTROLS */}
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                                    <div style={{ fontSize: 12, marginBottom: '-7px' }}>End</div>

                                                    <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                                                        <Select
                                                            showSearch
                                                            value={end.month()}
                                                            style={{ width: 100 }}
                                                            // className="dateRangedropDown custom-select"
                                                            onChange={(month) => {
                                                                const newDate = end.clone().month(month);
                                                                setdatemodified(prev => ({
                                                                    ...prev,
                                                                    end_date: newDate,
                                                                }));
                                                            }}
                                                            filterOption={(input, option) =>
                                                                option.props.children &&
                                                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                            }
                                                        >
                                                            {F.getMomentMonths().map((m, i) => (
                                                                <Option key={i} value={i}>{m}</Option>
                                                            ))}
                                                        </Select>

                                                        <Select
                                                            showSearch
                                                            value={end.year()}
                                                            style={{ width: 80 }}
                                                            // className="dateRangedropDown custom-select"
                                                            onChange={(year) => {
                                                                const newDate = end.clone().year(year);
                                                                setdatemodified(prev => ({
                                                                    ...prev,
                                                                    end_date: newDate,
                                                                }));
                                                            }}
                                                            filterOption={(input, option) =>
                                                                option.props.children &&
                                                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                                            }
                                                        >
                                                            {F.getYears().map((y) => (
                                                                <Option key={y} value={y}>{y}</Option>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                </div>

                                                {/* TODAY BUTTON */}
                                                <div
                                                    style={{
                                                        alignSelf: 'center', cursor: 'pointer',
                                                        color: '#1890ff',
                                                        marginTop: '10px'
                                                    }}
                                                    onClick={() => {
                                                        const today = moment().format("YYYY-MM-DD");

                                                        setdatemodified(prev => ({
                                                            ...prev,
                                                            start_date: today,
                                                            end_date: today
                                                        }));

                                                        // setOpen(false);
                                                    }}
                                                >
                                                    Today
                                                </div>

                                                {/* VIEW BUTTON */}

                                                <div
                                                    style={{
                                                        alignSelf: 'center'
                                                    }}>
                                                    <Button type="primary"
                                                        className="borderRadius-28 bg-164897"
                                                        style={{ marginTop: '15px' }}
                                                        onClick={() => {

                                                            setdatemodified(prev => ({
                                                                ...prev,
                                                                start_date: datemodified.start_date,
                                                                end_date: datemodified.end_date,
                                                            }));


                                                            handleRangeChange([datemodified.start_date, datemodified.end_date]);
                                                            setOpen(false);
                                                        }}
                                                    >
                                                        <Translate text={"Apply"}></Translate>
                                                    </Button>
                                                </div>
                                            </div>
                                        );
                                    }}
                                />


                            </Col>
                            {/* <Col span={8}>
                                <div className='datepicker-label-rsfs'>Start Date</div>
                                <DatePicker
                                    className='custom-datepicker'
                                    value={datemodified.start_date
                                        ? moment(datemodified.start_date)
                                        : null}
                                    format={dateFormat}
                                    onChange={(e) => { handleDateChange(e, 'start_date') }} />
                            </Col>
                            <Col span={8}>
                                <div className='datepicker-label-rsfs'>End Date</div>
                                <DatePicker
                                    className='custom-datepicker'
                                    value={datemodified.end_date
                                        ? moment(datemodified.end_date)
                                        : null}
                                    format={dateFormat}
                                    onChange={(e) => { handleDateChange(e, "end_date") }} />
                            </Col> */}

                            <Col span={8}>
                                <Button
                                    type="primary"
                                    className="refresh-con"
                                    onClick={() => refresh()}
                                >
                                    <Icon type="reload" />
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

            <Card
                type="inner"
                style={{ background: "#FAFAFA" }}
                title={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "20px",
                            }}
                        >
                            <Icon
                                type="folder"
                                style={{ marginRight: 10, color: "#1890ff" }}
                            />
                            <Translate
                                text={
                                    card.showName &&
                                        card.userName != undefined &&
                                        card.userName != ""
                                        ? `${card.userName}'s - ${title}`
                                        : title || "Upcoming Calls"
                                }
                            />
                        </div>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "40px",
                                overflowX: "auto",
                                // msOverflowStyle: "none",  /* IE and Edge */
                                // scrollbarWidth: "none",  /* Firefox */
                                // "&::-webkit-scrollbar": {  /* Chrome, Safari and Opera */
                                //     display: "none"
                                // }
                            }}
                        >
                            {card && card.hasAgentDropDown && (
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    placeholder="Search By Agent"
                                    className="dropDown custom-select agent-search-select"
                                    filterOption={false}
                                    onSearch={(value) => debouncedFetchAgents(value)}
                                    onChange={selectAgent}
                                    placement="bottomLeft"
                                    value={selectedAgent}
                                    notFoundContent={fetching ? <Spin size="small" /> : null}
                                    maxTagCount={0}
                                    maxTagPlaceholder={null}
                                    dropdownStyle={{
                                        maxHeight: 150,
                                        overflowY: "hidden",
                                        overflowX: "hidden",
                                    }}
                                    style={{
                                        fontSize: "small",
                                        width: windowWidth <= 769 ? "150px" : "100%",
                                    }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                >
                                    {agents &&
                                        agents.map((opt) => (
                                            <Option
                                                key={opt.user_id}
                                                value={opt.user_id}
                                                style={{ fontSize: "12px" }}
                                            >
                                                {opt.user_first_name} {opt.user_last_name}
                                            </Option>
                                        ))}
                                </Select>
                            )}

                            {(card.isLiveGrid || card.showHideBadPhoneNumberCheckbox) && (
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        minWidth: "max-content",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={isBadPhoneNumber}
                                        style={{
                                            width: "13px",
                                            height: "13px",
                                            cursor: "pointer",
                                            marginTop: "4px",
                                            marginLeft: "10px",
                                            accentColor: isBadPhoneNumber ? "#1890ff" : "#9ca3af",
                                        }}
                                        onChange={handleBadPhoneNumberToggle}
                                    />
                                    <span>Hide Bad Phone Number</span>
                                </div>
                            )}
                            {card && card.showMoreStats && (
                                <div
                                    className="hyperlink-shomore-stat"
                                    role="button"
                                    tabIndex="0"
                                    onClick={handleIconClick}
                                    onMouseEnter={(e) =>
                                        (e.currentTarget.style.textDecoration = "underline")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.textDecoration = "none")
                                    }
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            handleIconClick();
                                        }
                                    }}
                                    style={{ minWidth: "max-content" }}
                                >
                                    <Icon type="bar-chart" />
                                    Show More Stats
                                </div>
                            )}
                            {card && card.quickNavigation && (
                                <div
                                    role="button"
                                    tabIndex="0"
                                    className="hyperlink-shomore-stat"
                                    onClick={handleQuickNavigationModal}
                                    onMouseEnter={(e) =>
                                        (e.currentTarget.style.textDecoration = "underline")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.textDecoration = "none")
                                    }
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            handleQuickNavigationModal();
                                        }
                                    }}
                                    style={{ minWidth: "max-content" }}
                                >
                                    <Icon type="bar-chart" />
                                    Quick Navigation
                                </div>
                            )}
                        </div>
                    </div>
                }
                className="tableCard p_and_c_card"
            >
                <UserStatsModal
                    visible={isModalOpen}
                    onClose={handleCloseModal}
                    onCardClick={routeToRSFSGrid}
                />

                <QuickNavigationModal
                    visible={isQuickNavModalOpen}
                    onClose={handleQuickNavigationModalClose}
                    onCardClick={routeToRSFSGrid}
                />

                {/* Table and loader overlay logic for best popover UX */}
                <div style={{ position: "relative" }}>
                    {columnDefs.length ? (
                        <CustomAgGridTable
                            key={gridKey}
                            rowDatas={rowData}
                            columnDefss={columnDefs}
                            onGridReady={onGridReady}
                            onColumnMoved={saveState}
                            onSortChanged={saveState}
                            onFilterChanged={saveState}
                            frameworkComponents={{
                                CreateNameRendererRS,
                                CustomHeader,
                                CreatePhoneCellRenderer,
                                ButtonCellRenderer,
                            }}
                        />
                    ) : null}
                    {loading && (
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: "rgba(255,255,255,0.6)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 10,
                            }}
                        >
                            <Spin tip="Loading ..." />
                        </div>
                    )}
                </div>

                <div
                    style={{ float: "right", marginTop: "20px", marginBottom: "20px" }}
                >
                    <Pagination
                        current={currentPage}
                        total={totalPages * pageSize}
                        pageSize={pageSize}
                        showSizeChanger={false}
                        onChange={(page) => onPageChange(page)}
                    />
                </div>
            </Card>
        </div>
    );
};

export default RSFSGrid;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/rsfs-grid.js